<div class="container">
    <div class="col-md-4 d-flex align-items-center">
        <h2 class="reporte-no-ventas_title">
            {{ 'reporteHistoricos.tituloHistoricos' | translate }}
        </h2>
        <button
            class="btn btn-success ml-2 rounded-circle p-1 information-message"
            style="min-width: 30px"
            (click)="mostrarTexto()">
            <i class="fas fa-question"></i>
        </button>
    </div>

    <div class="col-10">
        <div class="form-group row-container">
            <app-date-picker
                [placeholder]="'Mes de inicio'"
                [dateValue]="startDate"
                (dateSelected)="onStartDateSelected($event)"></app-date-picker>

            <app-date-picker
                [placeholder]="'Mes final'"
                [dateValue]="endDate"
                [minDate]="startDate"
                [disabled]="!startDate"
                (dateSelected)="onEndDateSelected($event)"></app-date-picker>

            <button
                class="styles_btn-accept-query query_reports_btn"
                (click)="toConsult()"
                [disabled]="!startDate || !endDate"
                [ngClass]="{ 'disabled-btn': !startDate || !endDate }">
                Consultar
            </button>
            <button
                class="styles_btn-accept-query query_reports_btn"
                (click)="exportData()"
                [disabled]="!dataLoaded"
                [ngClass]="{ 'disabled-btn': !dataLoaded }">
                Exportar
            </button>
        </div>
    </div>
    <ng-container *ngIf="reportData && reportData.length > 0">
        <table class="table mt-3">
            <thead>
                <tr>
                    <th>Año del Reporte</th>
                    <th>Mes del Reporte</th>
                    <th>Modalidad de Carga</th>
                    <th>Fecha de Registro</th>
                    <th>Estado del Reporte</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let report of reportData">
                    <td>{{ report.anio }}</td>
                    <td>{{ report.periodoNombre }}</td>
                    <td>{{ report.modalidadCargue }}</td>
                    <td>{{ report.fechaRegistro }}</td>
                    <td>{{ report.estadoReporte }}</td>
                </tr>
            </tbody>
        </table>
    </ng-container>
    <div *ngIf="!reportData || reportData.length === 0">
        <p>No hay datos disponibles para mostrar.</p>
    </div>
</div>
